import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { BrandLogoComponent, ImportsModule } from '@mapa/ngx';
import { contactDetails } from '../../public/contact-us/data';
import { footerMenu } from '../menu-items';

@Component({
  selector: 'footer[app-footer]',
  standalone: true,
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImportsModule,
    RouterModule,
    BrandLogoComponent
  ],
  host: {
    'class': 'bg-surface-container-low'
  }
})
export class AppFooterComponent {
  protected readonly footerMenu = footerMenu;
  protected readonly contact = contactDetails;

  protected readonly icons = {
    faInstagram,
    faPhone,
    faEnvelope
  } as const;

  protected readonly legalLinks = [
    { text: 'Privacy Policy', url: '/privacy-policy' },
    { text: 'Terms of Service', url: '/terms-of-service' },
  ] as const;
}